
import { Component, Vue } from "vue-property-decorator";
import { DimssaButton } from "@/components/shared/dimssa-button.vue";
import BreadcrumbTrail from "@/components/BreadcrumbTrail.vue";
import { setupBreadcrumbs } from "@/utils/breadcrumbs";

interface BlendSessionMix {
  session: number;
  rationAGuid?: string;
  rationBGuid?: string;
  rationAPct?: number;
  rationBPct?: number;
}

interface BlendPlanDay {
  day: number;
  sessions: BlendSessionMix[];
}

interface BlendPlan {
  typename?: string;
  guid?: string;
  name: string;
  days?: number;
  dayPlans: BlendPlanDay[];
  creationDate?: number;
}

@Component({
  components: {
    DimssaButton,
    BreadcrumbTrail,
  },
})
export default class BlendPlans extends Vue {
  loading = false;
  tableKey = 0;
  blendPlans: BlendPlan[] = [];
  selected: BlendPlan[] = [];

  get themeClass(): string {
    return this.$store.state.lightDarkMode;
  }

  get breadcrumbs() {
    return setupBreadcrumbs({ text: "Blend Plans", disabled: true });
  }

  headers = [
    { text: "Name", value: "name", align: "center", sortable: true, filterable: true, divider: true },
    { text: "Days", value: "days", align: "center", sortable: true, filterable: true, divider: true },
  ];

  mounted() {
    this.$store.dispatch("user/addFirebaseCallback", this.getData);
  }

  forceRerender() {
    this.tableKey += 1;
  }

  addBlendPlan() {
    this.onClickEdit();
  }

  removeBlendPlan() {
    if (this.selected.length > 0) {
      this.blendPlans = this.blendPlans.filter((bp) => bp.guid !== this.selected[0].guid);
      this.forceRerender();
    }
  }

  onClickEdit() {
    const item: BlendPlan =
      this.selected[0] ??
      ({
        guid: `${Date.now()}`,
        name: "",
        dayPlans: [],
        typename: "BlendPlan",
      } as BlendPlan);
    this.$store.commit("updateField", {
      path: "blendPlan",
      value: item,
    });
    this.$router.push({ name: "blendPlan" });
  }

  async getData() {
    this.loading = true;
    try {
      const gql = `query($guid:String!){
        BlendPlans(guid:$guid){
          guid
          typename
          name
          days
          dayPlans{
            day
            sessions{
              session
              rationAGuid
              rationBGuid
              rationAPct
              rationBPct
            }
          }
        }
      }`;
      const json = await this.$store.dispatch("graphQl", {
        gql,
        variables: { guid: this.$store.state.user.location.guid },
      });
      this.blendPlans = json.data.BlendPlans ?? [];
    } catch (err) {
      console.log("getBlendPlans -> error: " + err);
    } finally {
      this.loading = false;
    }
  }
}
